import React from 'react';
import { CheckoutButton } from './CheckoutButton';
import { Countdown } from './Countdown';
import { TrustBar } from './TrustBar';
import { checkoutUrl, productImage } from '../data/content';
export function PricingCard() {
  return <section id="pricing" className="scroll-mt-0 bg-brand-navy px-4 py-4 text-white sm:px-6 sm:py-5" aria-labelledby="offer-heading" data-id="element-112" data-mp="1m4tas414g2dz">
      <div className="mb-2.5 text-center" data-id="element-113" data-mp="2eti3beo42ze4">
        <h2 id="offer-heading" className="mb-1 text-[19px] font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-114" data-mp="2esgu7fqnomz1">
          Offerta Speciale — Sistema Completo 6-in-1
        </h2>
        <p className="mb-2 text-[12px] font-medium leading-snug text-white/85 sm:text-sm" data-id="element-115" data-mp="251ceuex2j03o">
          Accedi subito al sistema completo e rivoluziona il modo in cui prepari le tue lezioni.
        </p>
        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-116" data-mp="2xkrfxwt6i49x">
          <img src={productImage} alt="PADEL MASTER PRO — sistema completo 6-in-1" className="mx-auto w-full max-w-[240px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-117" data-mp="32l44q75zy613" />
        </a>
      </div>
      <div className="mx-auto max-w-md rounded-xl border-2 border-brand-green bg-white p-3 text-center text-brand-ink shadow-2xl sm:p-3.5" data-id="element-118" data-mp="2xrsya753jr9p">
        <p className="text-[12px] font-extrabold leading-tight text-brand-navy sm:text-sm" data-id="element-119" data-mp="2osnv2nilb9r7">
          🎾 PADEL MASTER PRO™ — Sistema Completo 6-in-1 per Istruttori e Maestri di Padel
        </p>
        <p className="mt-1.5 text-[12px] font-semibold text-brand-muted" data-id="element-120" data-mp="2euhvwdo64hq1">
          Prezzo di Listino: <span className="line-through" data-id="element-121" data-mp="84jsbtmljy7n">97€</span>
        </p>
        <p className="mx-auto my-1 max-w-xs rounded-md bg-brand-red/10 px-2 py-1 font-heading text-[11px] font-extrabold uppercase leading-tight text-brand-red sm:text-xs" data-id="element-122" data-mp="853a9ac8ymlo">
          🔥 72% di Sconto — Offerta di Lancio a Tempo Limitato
        </p>
        <p className="font-heading text-[26px] font-extrabold uppercase leading-none text-brand-navy sm:text-4xl" data-id="element-123" data-mp="6mlhu9tc2ym5">
          Oggi Solo: <span className="text-brand-green" data-id="element-124" data-mp="1otduhfezm1l">27€</span>
        </p>
        <p className="mb-2 mt-1 text-[10px] font-medium text-brand-muted" data-id="element-125" data-mp="3ts446x6pd29t">
          Pagamento sicuro nella tua valuta.
        </p>
        <div className="mx-auto mb-2 max-w-[260px]" data-id="element-126" data-mp="ube4ffo2fu43">
          <Countdown data-id="element-127" data-mp="pdmayh7rvzxs" />
        </div>
        <p className="mb-2 text-[10px] font-medium text-brand-muted" data-id="element-128" data-mp="penoqtg6b0j7">
          Questa offerta terminerà allo scadere del conto alla rovescia.
        </p>
        <CheckoutButton data-id="element-129" data-mp="kkjkihyal6lt">🚀 SÌ! VOGLIO PADEL MASTER PRO™ ORA</CheckoutButton>
        <div className="mt-2" data-id="element-130" data-mp="gl2cphve7xdh">
          <TrustBar variant="light" data-id="element-131" data-mp="1d3705huirtfi" />
        </div>
      </div>
    </section>;
}